<template>
    <div class="takequiz">
    <h2>{{freeChoices.question}}</h2>
    
   <hr>
     <ul>
        <li v-for="choice in freeChoices.choices" :key="choice">
            <button v-on:click="answerFreeThrow(freeChoices,choice)">{{choice}}</button>
           {{freeChoices}}
            </li>
    </ul>
    </div>
</template>
<script>
export default {
  name: 'FreeThrow',
  props: {
    msg: String,
    freeChoices: {
        type: Object
    }
  },
  methods: {
      answerFreeThrow: function (answer,choice){
          console.log('free throw attempt')
        console.log('i choose ', choice)
        let submit = {
          choice: choice,
          answer: answer.correctAnswer
        }
        this.$emit('gradeFT',submit)
      }
  }
}
</script>

<style>

</style>
